<template>
    <div>
        <sau-service-status :service="service"></sau-service-status>

        <template v-if="formatted">
            <firewall-summary :service="service" class="pt-12"></firewall-summary>
        </template>
    </div>
</template>

<script>
import FirewallSummary from '@v1/service/firewall/_System';

export default {
    props: ['service'],

    components: { FirewallSummary },

    data() {
        return {
            formatted: false,
        }
    },

    created() {
        // Lock down functionality if the service is suspended
        if (this.service.status.toLowerCase() != 'suspended') {
            this.service.custom['IP Address'] = this.service.ipaddress;
            this.service.custom['Domain'] = this.service.domain;
            this.service.custom['Assigned IPs'] = this.service.assignedips;
            this.formatted = true;
        }
    },
}
</script>
